import { render, staticRenderFns } from "./img-with-no-image-error.vue?vue&type=template&id=9fae4778"
import script from "./img-with-no-image-error.vue?vue&type=script&lang=js"
export * from "./img-with-no-image-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports